module.exports = __webpack_public_path__ + "static/img/arthroscopy-15.6453de3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/arthroscopypic/arthroscopy-15.jpg
// module id = leov
// module chunks = 52